<script lang="ts">
  export let size: number = 22;
  // export let color: '#FF0000' | '#ADB9C5' = '#ADB9C5';
</script>

<svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M13.7 2.58337C12.1917 2.58337 10.8417 3.31671 10 4.44171C9.15835 3.31671 7.80835 2.58337 6.30002 2.58337C3.74169 2.58337 1.66669 4.66671 1.66669 7.24171C1.66669 8.23337 1.82502 9.15004 2.10002 10C3.41669 14.1667 7.47502 16.6584 9.48335 17.3417C9.76669 17.4417 10.2334 17.4417 10.5167 17.3417C12.525 16.6584 16.5834 14.1667 17.9 10C18.175 9.15004 18.3334 8.23337 18.3334 7.24171C18.3334 4.66671 16.2584 2.58337 13.7 2.58337Z"
    class={$$props.class || "fill-blueish-grey-500"}
  />
</svg>
